import React from 'react';

import { BackgroundCardWrapper } from './BackgroundCardWrapper';
import { createMarkup } from '../../utils';

interface IProps {
    position: ClientRect;
    nextQuestionText: string;
    nextQuestionSubText?: string;
}

export const BackgroundCard: React.FC<IProps> = ({
    position,
    nextQuestionText,
    nextQuestionSubText,
}) => (
    <BackgroundCardWrapper position={position}>
        <div dangerouslySetInnerHTML={createMarkup(nextQuestionText)} />
        {nextQuestionSubText && <div>{nextQuestionSubText}</div>}
    </BackgroundCardWrapper>
);
